<template>
  <div class="aiPanelDes" style="height: 200px">
    <el-calendar>
      <template
        slot="dateCell"
        slot-scope="{date, data}">
        <p @click="TarihSecim(data,date)" :class="data.isSelected ? 'is-selected' : ''">
          {{ data.day.split('-').slice(1)[1] }}
        </p>
      </template>
    </el-calendar>
    <el-dialog v-if="ModalOlayi" :title="Baslik" :visible.sync="ModalOlayi" width="30%">
      <a @click="ModalOlayi = false" class="ModalKapat"><i class="el-icon-close"></i></a>
      <Yukleniyor :data="lo"></Yukleniyor>
      <el-alert
        title="Takvim kaydı yok"
        type="success"
        :closable="false"
        v-if="!Liste">
      </el-alert>
      <el-table
        class="table-xs"
        style="width: 100%"
        width="100%"
        :data="Liste"
        v-if="Liste"
        height="300px">
        <el-table-column
          prop="Aciklama"
          label="Açıklama">
        </el-table-column>
      </el-table>
    </el-dialog>
  </div>
</template>

<script>
import Yukleniyor from "../../Doc/Yukleniyor";

export default {
  components: {Yukleniyor},
  data() {
    return {
      ModalOlayi: false,
      Baslik: null,
      Liste: null
    }
  },
  methods: {
    TarihSecim(e) {
      this.ModalOlayi = true
      this.$store.dispatch("Get", {path: 'panel/takvim/4/' + e.day})
        .then(response => {
          if (response.Durum === 'OK') {
            this.Liste = response.Liste;
            this.Baslik = response.SorguTarih;
            this.lo = false;
          } else {
            this.$message.error(response.Mesaj);
          }
        });
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Pack/Panel/PanelCalendar.vue